export var HorizontalRule = 'hr';